import React from "react";

/**
 * head: ["", "Col A", "Col B"]   rows: [["Label", valueA, valueB], ...]
 * `highlight` = index of the column to emphasise. Boolean cells render as ✓ / —.
 */
export default function CompareTable({ head, rows, highlight = -1 }) {
  return (
    <div className="table-wrap">
      <table className="compare-table">
        <thead>
          <tr>{head.map((h, i) => <th key={i} className={i === highlight ? "hl" : ""}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row[0]}>
              {row.map((cell, i) => {
                const isBool = typeof cell === "boolean";
                const cls = [i === highlight && "hl", isBool && (cell ? "yes" : "no")].filter(Boolean).join(" ");
                return (
                  <td key={i} className={cls}>
                    {isBool ? (cell ? "✓" : "—") : i === 0 || i === highlight ? <b>{cell}</b> : cell}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
